import { colorsPalettes } from "@similarweb/styles";
import styled from "styled-components";
import { LoaderListItemsWrapper } from "pro-features/components/Loaders/src/LoaderListItems";
import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { Autocomplete } from "@similarweb/ui-components";
import { ScrollArea } from "@similarweb/ui-components";
import type { IAutocompleteStyledProps } from "pro-features/components/AutocompleteWebsites/types";

const SegmentUrlListLoaderContainer = styled.div`
    width: 426px;
    height: 466px;
    & ${LoaderListItemsWrapper} {
        padding-top: 50px;
    }
`;

const SegmentUrlListElementContainer = styled.div<{ hasBottomMargin: boolean }>`
    padding: 0 24px;
    margin-bottom: ${(props) => (props.hasBottomMargin ? "16px" : "0")};

    .DropdownButton {
        background-color: ${colorsPalettes.bluegrey[100]};
    }
`;

/**
 * Style for the filter button when no item is selected
 */
const SegmentUrlListFilterButtonDefaultText = styled.div`
    color: ${colorsPalettes.carbon[500]};
    opacity: 0.4;
`;

export const SearchWrapper = styled(FlexColumn)`
    align-items: center;
`;

export const AutocompleteStyled = styled(Autocomplete)<IAutocompleteStyledProps>`
    width: 324px;
    margin-top: 20px;
    border-radius: 0;
    .AutoCompleteContainer {
        box-shadow: 0 0 0 0;
        padding: 0 0;
        background-color: ${colorsPalettes.carbon[0]};
        transform: translateY(0);
    }
`;

export const Separator = styled.div`
    margin-top: 8px;
    width: 324px;
    height: 1px;
    background-color: ${colorsPalettes.carbon[200]};
`;

/**
 * Style for the filter button when an item is selected
 */
const SegmentUrlListFilterSelectedButtonText = styled.div`
    color: ${colorsPalettes.carbon[500]};
`;

export const SegmentUrlListItemContainer = styled.div`
    padding: 8px 13px;
    box-sizing: border-box;
    white-space: normal;
    word-break: break-all;
    hyphens: none;
    color: ${colorsPalettes.carbon[500]};
    font-family: Roboto;
    font-size: 14px;
    text-decoration: none;

    & + & {
        border-top: 1px solid ${colorsPalettes.bluegrey[200]};
    }

    & > span {
        &.keywordMatch,
        &.exactMatch {
            font-weight: bold;
        }

        &.shrinked {
            color: ${colorsPalettes.carbon[300]};
        }
    }
`;

export const UrlsScrollArea = styled(ScrollArea)`
    white-space: nowrap;
    text-overflow: ellipsis;
    margin-bottom: 17px;
    z-index: 99;
    padding: 0 24px;
    height: 77%;

    @media screen and (max-height: 730px) {
        height: 70%;
    }
`;
